import { defineComponent as _defineComponent } from 'vue'
import { createVNode as _createVNode, createElementVNode as _createElementVNode, unref as _unref, toDisplayString as _toDisplayString, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, withCtx as _withCtx, Fragment as _Fragment, createElementBlock as _createElementBlock, createTextVNode as _createTextVNode, normalizeClass as _normalizeClass, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-c00a45fa"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "main" }
const _hoisted_2 = { class: "block-info-list" }
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "label" }, "责任判定", -1))
const _hoisted_4 = { class: "value" }
const _hoisted_5 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "label" }, "故障类型", -1))
const _hoisted_6 = { class: "value" }
const _hoisted_7 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "label" }, "是否炸机", -1))
const _hoisted_8 = { class: "value" }
const _hoisted_9 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "label" }, "故障现象综合分析", -1))
const _hoisted_10 = { class: "value" }
const _hoisted_11 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "label" }, "故障附图", -1))
const _hoisted_12 = { class: "value" }
const _hoisted_13 = { class: "block-info-list" }
const _hoisted_14 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("li", null, [
  /*#__PURE__*/_createElementVNode("div", { class: "label" }, "定责阶段"),
  /*#__PURE__*/_createElementVNode("div", { class: "value" }, "已定责")
], -1))
const _hoisted_15 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "label" }, "定责时间", -1))
const _hoisted_16 = { class: "value" }
const _hoisted_17 = { key: 1 }
const _hoisted_18 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "label" }, "分析时间", -1))
const _hoisted_19 = { class: "value" }
const _hoisted_20 = {
  key: 2,
  class: "y-center"
}
const _hoisted_21 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "label" }, "分析报告", -1))
const _hoisted_22 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", { class: "icon-right-green-svg" }, null, -1))
const _hoisted_23 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "pay-item-left" }, [
  /*#__PURE__*/_createElementVNode("div", { class: "pay-icon" }),
  /*#__PURE__*/_createElementVNode("div", { class: "pay-item-description" }, "已支付服务费")
], -1))
const _hoisted_24 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "icon-arrow-right-svg" }, null, -1))
const _hoisted_25 = [
  _hoisted_23,
  _hoisted_24
]
const _hoisted_26 = {
  key: 2,
  class: "systemAnalysis-tips-wrap"
}
const _hoisted_27 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "systemAnalysis-tips" }, " 报告说明：本报告由系统自动分析生成，可快速获取基础结论。如需人工开展详细数据分析，可申请人工定责服务 ", -1))
const _hoisted_28 = [
  _hoisted_27
]
const _hoisted_29 = {
  key: 0,
  class: "button-tips"
}
const _hoisted_30 = { class: "button-wrap" }

import { useRoute, useRouter } from 'vue-router'
import { computed, onActivated, Ref, ref } from 'vue'
import { commonErrorHandle } from '@/utils/error-handle'
import { showToastLoading, clearToast } from '@/utils/tools'
import { getOrderAssociatedResponsible,getPayOrderDetail } from '@/apis/malfunction-repair'
import { useMalfunctionRepairStore } from '@/compositions/malfunction-repair'
import { GetOrderAssociatedResponsibleResult,GetPayOrderDetailResult } from '@/types/malfunction-repair'
import AppHeader from '@/components/Header.vue'
import BlockkWrapper from './components/block-wrap.vue'
import CommonFooterWrap from '@/components/CommonFooterWrap.vue'
import CommonImagePreview from '@/components/CommonImagePreview.vue'
import ConfirmButton from './components/service-order/analysis-confirm-button.vue'
import ApplyButton from './components/service-order/analysis-apply-button.vue'

import { defineComponent } from 'vue'
const __default__ = defineComponent({
  name: 'malfunction-repair-repair-order-duty-result',
})

export default /*#__PURE__*/_defineComponent({
  ...__default__,
  setup(__props) {

const $router = useRouter()
const $route = useRoute()
const detail: Ref<null | GetOrderAssociatedResponsibleResult> = ref(null)
let paramsDetail: null | GetOrderAssociatedResponsibleResult = $route.params.detail
  ? JSON.parse($route.params.detail as string)
  : null
const guid = $route.query.guid as string
const from = $route.query.from as string
const workGuid = $route.query.workGuid as string
const isPlant = $route.query.isPlant === 'true'
const { removeOrderDutyResultItemKeepAlive, addOrderDutyResultItemKeepAlive } =
  useMalfunctionRepairStore()
const analysis = computed(() => {
  return detail.value?.responsible_work_order?.responsible_analysis
})
const isformServiceOrder = computed(() => {
  return from === 'service-order'
})
const faultTypeText = computed(() => {
  if (!analysis.value || !analysis.value.fault_type) {
    return ''
  }
  const arr = analysis.value.fault_type
  return arr.pop()
})
const showButtonLine = computed(() => {
  return (
    isformServiceOrder.value &&
    waitConfirm.value &&
    !isHardWare.value &&
    (isSystemAnalysis.value || isTechnicalSupport.value)
  )
})
const imageGuids = computed(() => {
  return detail.value?.responsible_work_order?.responsible_analysis?.images
})
const isAfterVerify = computed(() => {
  // 审核后
  const status = detail.value?.responsible_work_order?.status
  return status === 'WAIT_CONFIRM' || status === 'END'
})
const isAfterAnalysis = computed(() => {
  // 分析后
  const status = detail.value?.responsible_work_order?.status
  return status === 'WAIT_VERIFY' || isAfterVerify.value
})
const isShowAnalysisReport = computed(() => {
  // 显示定责分析报告
  return isAfterAnalysis.value && isTechnicalSupport.value
})
const isEnd = computed(() => {
  return detail.value?.responsible_work_order?.status === 'END'
})
const responsible = computed(() => {
  return detail.value?.responsible_work_order
})
const waitConfirm = computed(() => {
  return responsible.value?.status === 'WAIT_CONFIRM'
})
const isHardWare = computed(() => {
  return responsible.value?.analysis_responsibility_type === 'HARDWARE'
})
const canAppeal = computed(() => {
  return (
    (responsible.value?.appeal_num !== undefined && responsible.value?.appeal_num <= 1) ||
    (!isHardWare.value && isSystemAnalysis.value && waitConfirm.value)
  )
})

const isSystemAnalysis = computed(() => {
  // 是否为系统分析
  return responsible.value?.type === 1
})
const isTechnicalSupport = computed(() => {
  // 是否为技术支持类型
  return responsible.value?.type === 3
})
async function initPageDetail() {
  try {
    const data = paramsDetail || (await getOrderAssociatedResponsible(guid))
    paramsDetail = null // 只使用一次
    detail.value = data
  } catch (error) {
    commonErrorHandle(error)
  }
}
function checkReportHandle() {
  addOrderDutyResultItemKeepAlive()
  setTimeout(() => {
    $router.push({
      name: 'malfunction-repair-repair-order-report',
      query: {
        guid,
      },
    })
  }, 50)
}


let payOrderDetail= ref<GetPayOrderDetailResult>()

  async function getPayOderInfo() {
  // 获取付费定责详情
  try {
    payOrderDetail.value = await getPayOrderDetail(workGuid)
  }catch(e) {

  }
}


function updateHandle() {
  setTimeout(() => {
    initData()
  }, 1500)
}


  async function initData() {
  let result  = [initPageDetail()]
  if(workGuid) {
    result.push(getPayOderInfo())
  }
  try {
    showToastLoading()
    await Promise.all(result)
  }catch(e) {
    commonErrorHandle(e)
  }
  clearToast()

}

function viewPayInfo () {
  $router.push({
    name: 'malfunction-repair-service-fee-invoice',
    query: {
      guid: workGuid,
      isDetail: 'true'
    }

  })
}


initData()
onActivated(() => {
  removeOrderDutyResultItemKeepAlive()
})

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createVNode(AppHeader, { title: "定责结果" }),
    _createElementVNode("div", _hoisted_1, [
      _createVNode(BlockkWrapper, {
        title: "定责审核",
        class: "block-item"
      }, {
        default: _withCtx(() => [
          _createElementVNode("ul", _hoisted_2, [
            _createElementVNode("li", null, [
              _hoisted_3,
              _createElementVNode("div", _hoisted_4, [
                _createElementVNode("div", null, _toDisplayString(_unref(analysis)?.work_order_result_text), 1)
              ])
            ]),
            _createElementVNode("li", null, [
              _hoisted_5,
              _createElementVNode("div", _hoisted_6, _toDisplayString(_unref(faultTypeText)), 1)
            ]),
            _createElementVNode("li", null, [
              _hoisted_7,
              _createElementVNode("div", _hoisted_8, _toDisplayString(_unref(analysis)?.is_plane_crash_text), 1)
            ]),
            _createElementVNode("li", null, [
              _hoisted_9,
              _createElementVNode("div", _hoisted_10, _toDisplayString(_unref(analysis)?.description), 1)
            ]),
            _createElementVNode("li", null, [
              _hoisted_11,
              _createElementVNode("div", _hoisted_12, [
                (_unref(imageGuids))
                  ? (_openBlock(), _createBlock(CommonImagePreview, {
                      key: 0,
                      guids: _unref(imageGuids)
                    }, null, 8, ["guids"]))
                  : _createCommentVNode("", true)
              ])
            ])
          ])
        ]),
        _: 1
      }),
      (_unref(isAfterAnalysis))
        ? (_openBlock(), _createBlock(BlockkWrapper, {
            key: 0,
            title: "",
            class: "block-item"
          }, {
            default: _withCtx(() => [
              _createElementVNode("ul", _hoisted_13, [
                (_unref(isAfterVerify))
                  ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                      _hoisted_14,
                      _createElementVNode("li", null, [
                        _hoisted_15,
                        _createElementVNode("div", _hoisted_16, _toDisplayString(detail.value?.responsible_work_order?.verified_at), 1)
                      ])
                    ], 64))
                  : (_unref(isAfterAnalysis))
                    ? (_openBlock(), _createElementBlock("li", _hoisted_17, [
                        _hoisted_18,
                        _createElementVNode("div", _hoisted_19, _toDisplayString(detail.value?.responsible_work_order?.analysis_at), 1)
                      ]))
                    : _createCommentVNode("", true),
                (_unref(isShowAnalysisReport))
                  ? (_openBlock(), _createElementBlock("li", _hoisted_20, [
                      _hoisted_21,
                      _createElementVNode("div", {
                        class: "value value-btn",
                        onClick: checkReportHandle
                      }, [
                        _createTextVNode(" 查看报告"),
                        _hoisted_22
                      ])
                    ]))
                  : _createCommentVNode("", true)
              ])
            ]),
            _: 1
          }))
        : _createCommentVNode("", true),
      (_unref(payOrderDetail))
        ? (_openBlock(), _createBlock(BlockkWrapper, {
            key: 1,
            title: "",
            class: "block-item"
          }, {
            default: _withCtx(() => [
              _createElementVNode("div", {
                class: _normalizeClass({'pay-item': true,'success':_unref(payOrderDetail)?.status === 2,'cancel': _unref(payOrderDetail)?.status === 3}),
                onClick: viewPayInfo
              }, _hoisted_25, 2)
            ]),
            _: 1
          }))
        : _createCommentVNode("", true),
      (detail.value)
        ? (_openBlock(), _createElementBlock("div", _hoisted_26, _hoisted_28))
        : _createCommentVNode("", true)
    ]),
    (_unref(showButtonLine))
      ? (_openBlock(), _createBlock(CommonFooterWrap, { key: 0 }, {
          default: _withCtx(() => [
            (_unref(isTechnicalSupport) && _unref(responsible)?.appeal_num === 2)
              ? (_openBlock(), _createElementBlock("div", _hoisted_29, " * 申诉次数已达上限！ "))
              : _createCommentVNode("", true),
            _createElementVNode("div", _hoisted_30, [
              (_unref(canAppeal))
                ? (_openBlock(), _createBlock(ApplyButton, {
                    key: 0,
                    guid: _unref(guid),
                    from: "duty-result",
                    canAppeal: _unref(canAppeal),
                    isSystemAnalysis: _unref(isSystemAnalysis),
                    isTechnicalSupport: _unref(isTechnicalSupport),
                    onUpdate: updateHandle,
                    isPlant: isPlant
                  }, null, 8, ["guid", "canAppeal", "isSystemAnalysis", "isTechnicalSupport"]))
                : _createCommentVNode("", true),
              _createVNode(ConfirmButton, {
                from: "duty-result",
                showMarginLeft: _unref(canAppeal),
                onUpdate: updateHandle,
                guid: _unref(guid)
              }, null, 8, ["showMarginLeft", "guid"])
            ])
          ]),
          _: 1
        }))
      : _createCommentVNode("", true)
  ], 64))
}
}

})